import { Placement } from '@popperjs/core';
import styled, { css, createGlobalStyle } from 'styled-components';

import TextInput from '../TextInput';

export const AutoSuggestInputGlobalStyles = createGlobalStyle`
  .iA_Core_AutoSuggestInput-highlight {
    text-decoration: underline;
    background: transparent;
  }
`;

export const StyledInput = styled(TextInput)<{
  isOpened?: boolean;
  placement?: Placement;
}>`
  ${({ isOpened, placement }) => isOpened && placement === 'bottom' && css`
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `}

  ${({ isOpened, placement }) => isOpened && placement === 'top' && css`
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  `}
`;

export const StyledIcon = styled.svg`
  position: relative;
  top: -2px;
  color: ${({ theme }) => theme.colors.gray8};
  width: 24px;
  height: 24px;
`;
